import React, { useEffect, useState } from "react";
import DynamicTable from "../../Components/Table/DynamicTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllMembers } from "../../Redux/Slice/AddMember";
import Loader from "../../Components/Loader/Loader";

const ProfileModal = ({ isOpen, onClose, profileData }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-[32px] rounded-md border-2 border-black w-[400px] max-w-md max-h-[80vh] overflow-y-auto shadow-xl">
        <h2 className="text-xl font-medium mb-1 text-start">Profile Details</h2>

        {profileData ? (
          <div className="space-y-3 text-md">
            <div className="flex justify-start">
              <img
                src={profileData.ProfilePhoto}
                alt={profileData.name}
                className="w-[100px] h-[100px] rounded-full object-cover border"
              />
            </div>
            <div className="mt-4">
              <p className="text-[#212529] mb-4">
                <strong>ID:</strong> {profileData.id}
              </p>
              <p className="text-[#212529] mb-4">
                <strong>Name:</strong> {profileData.name}
              </p>
              <p className="text-[#212529] mb-4">
                <strong>Email:</strong> {profileData.Email}
              </p>
              <p className="text-[#212529] mb-4">
                <strong>Mobile Number:</strong> {profileData.mobileNumber}
              </p>
              <p className="text-[#212529] mb-4">
                <strong>Position:</strong> {profileData.position}
              </p>
              <p className="text-[#212529] mb-4">
                <strong>Status:</strong> {profileData.status}
              </p>
              <p className="text-[#212529] mb-4">
                <strong>Working Schedule:</strong> {profileData.CheckInTime} to {profileData.CheckOutTime}
              </p>
            </div>
          </div>
        ) : (
          <p className="text-center text-gray-500">
            No profile data available.
          </p>
        )}

        <div className="mt-6 text-start">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#122A47] text-white rounded"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const ShowAllMember = () => {
  const dispatch = useDispatch();

  const { MemberData } = useSelector((state) => state.AddMemberSlice);

  useEffect(() => {
    dispatch(fetchAllMembers());
  }, [dispatch]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  const handleViewProfile = (profileData) => {
    setSelectedProfile(profileData);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProfile(null);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "mobileNumber", headerName: "Mobile Number", flex: 1 },
    { field: "position", headerName: "Position", flex: 1 },
    { field: "status", headerName: "Status", flex: 1 },
    {
      field: "profileLink",
      headerName: "Profile",
      flex: 1,
      renderCell: (params) => (
        <button
          onClick={() => handleViewProfile(params.row)}
          className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-blue-600"
        >
          View Profile
        </button>
      ),
    },
  ];

  const rows =
    MemberData?.data
      ?.filter((el) => el.Profile && el.Profile.includes("On")) // Filter positions containing "On"
      .map((el, index) => ({
        id: el.id || index + 1,
        MainId: el._id,
        mobileNumber: el.MobileNumber,
        name: el.Name,
        Email: el.Email,
        Password: el.Password,
        position: el.Role,
        Address: el.Address,
        ProfilePhoto: el.ProfilePhoto,
        JoiningDate: el.JoiningDate,
        status: el.Profile,
        CheckInTime: el.CheckInTime || "10:00",
        CheckOutTime: el.CheckOutTime || "19:00",
      })) || [];

  if (!MemberData?.data || !MemberData) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <h3 className="text-xl font-bold text-white px-4 py-2 inline-block rounded bg-[#133a69]">
          Show All Members
        </h3>

        <div className="my-5">
          <DynamicTable columns={columns} rows={rows} />
        </div>
      </div>

      <ProfileModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        profileData={selectedProfile}
      />
    </>
  );
};

export default ShowAllMember;
